import { useState } from 'react'
import { Box, Typography } from '@mui/material'
import { useScrollReveal } from '../use-scroll-reveal'
import { FEATURES } from './features-data.jsx'
import { FeatureCard } from './feature-card'

export const FeaturesSection = () => {
  const [flippedIndex, setFlippedIndex] = useState(null)
  const { ref, visible } = useScrollReveal(0.1)

  const handleFlip = (index) => {
    setFlippedIndex((prev) => (prev === index ? null : index))
  }

  return (
    <Box sx={{ px: { xs: 3, md: 6 }, py: { xs: 8, md: 10 } }}>
      <Box
        ref={ref}
        sx={{
          textAlign: 'center',
          mb: 6,
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.5s ease, transform 0.5s ease',
        }}
      >
        <Typography variant="overline" color="primary" fontWeight={600} letterSpacing={2}>
          Features
        </Typography>
        <Typography variant="h4" fontWeight={700} mt={0.5}>
          Everything your farm needs
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
          gridAutoRows: '280px',
          gap: 3,
          maxWidth: 1100,
          mx: 'auto',
        }}
      >
        {FEATURES.map((feature, i) => (
          <FeatureCard
            key={feature.title}
            feature={feature}
            index={i}
            isFlipped={flippedIndex === i}
            onFlip={() => handleFlip(i)}
          />
        ))}
      </Box>
    </Box>
  )
}
